import { useMemo } from 'react';

// Fonctions de calcul pures
const calculateFootage = (numberOfPallets, palletType) => {
  if (
    !numberOfPallets ||
    Number(numberOfPallets) <= 0 ||
    !palletType ||
    palletType === 'COLIS' ||
    palletType === 'AUTRE'
  ) {
    return null;
  }

  const pallets = Number(numberOfPallets);
  let footage;
  switch (palletType) {
    case '80 x 120':
      footage = pallets * 0.4;
      break;
    case '100 x 120':
      footage = pallets * 0.5;
      break;
    case '120 x 120':
      footage = pallets * 0.6;
      break;
    case '80 x 60':
      footage = pallets * 0.2;
      break;
    default:
      return null;
  }
  return parseFloat(footage.toFixed(2));
};

const calculateMargin = (clientPrice, carrierPrice) => {
  if (!clientPrice || !carrierPrice) return 0;
  return Number(clientPrice) - Number(carrierPrice);
};

const calculateMarginRate = (clientPrice, carrierPrice) => {
  if (!clientPrice || !carrierPrice || Number(carrierPrice) === 0) return 0;
  return (Number(clientPrice) - Number(carrierPrice)) / Number(carrierPrice);
};

const calculateTva = (price, tvaRate) => {
  if (!price || tvaRate === null || tvaRate === undefined) return 0;
  return (Number(price) * Number(tvaRate)) / 100;
};

export const useFormCalculations = (formData, skipFootageCalculation = false) => {
  return useMemo(() => {
    const margin = calculateMargin(formData.client_price, formData.carrier_price);
    const marginRate = calculateMarginRate(formData.client_price, formData.carrier_price);
    const clientTva = calculateTva(formData.client_price, formData.client_tva_rate);
    const carrierTva = calculateTva(formData.carrier_price, formData.carrier_tva_rate);

    const result = {
      margin,
      margin_rate: marginRate,
      client_tva: clientTva,
      carrier_tva: carrierTva,
      client_total: Number(formData.client_price || 0) + clientTva,
      carrier_total: Number(formData.carrier_price || 0) + carrierTva,
    };

    if (!skipFootageCalculation) {
      result.footage = calculateFootage(formData.number_of_pallets, formData.pallet_type);
    }

    return result;
  }, [
    formData.number_of_pallets,
    formData.pallet_type,
    formData.client_price,
    formData.carrier_price,
    formData.client_tva_rate,
    formData.carrier_tva_rate,
    skipFootageCalculation,
  ]);
};
